import { useTranslation } from 'react-i18next'

import classNames from 'classnames'

import classes from './EtlNoteThemePicker.module.scss'

interface EtlNoteThemePickerIconProps {
  theme: string
  selectedTheme?: string
  selectTheme: (theme: string) => void
  selectTemporaryTheme: (theme?: string) => void
}

export const EtlNoteThemePickerIcon = ({
  selectedTheme,
  theme,
  selectTheme,
  selectTemporaryTheme
}: EtlNoteThemePickerIconProps) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'notes.theme'
  })

  return (
    <button
      type="button"
      aria-label={t('themePickerAriaLabel', { theme })}
      onClick={(e) => {
        e.stopPropagation()
        selectTheme(theme)
      }}
      onMouseEnter={() => {
        selectTemporaryTheme(theme)
      }}
      tabIndex={0}
      className={classNames({
        [classes.EtlNoteThemePicker__Icon]: true,
        [classes[`EtlNoteThemePicker__Icon--${theme}`]]: true,
        [classes['EtlNoteThemePicker__Icon--selected']]: theme === selectedTheme
      })}
    />
  )
}
